import { Document, EDocumentType } from '../models/Document';
import { NotificationHelper } from './NotificationHelper';

export class DocumentHelper {
  public static getHumanSize(sizeByte: number): string {
    if (sizeByte < Document.KB) {
      return `${sizeByte} Bytes`;
    } else if (sizeByte < Document.MB) {
      return `${Math.ceil(sizeByte / Document.KB)} KB`;
    } else if (sizeByte < Document.GB) {
      return `${(sizeByte / Document.MB).toFixed(2)} MB`;
    } else {
      return `${(sizeByte / Document.GB).toFixed(2)} GB`;
    }
  }

  public static openDocumentInWindow(document: Document, type: EDocumentType, onDownloadDocument: (document: Document, type: EDocumentType) => Promise<Blob>): void {
    // We open a new tab immediately so the browser knows that it's origin was the user click
    // and thus does not block the window. After we get a blob-href we load it into the new
    // window. If we do all of this in the promise we will get blocked since the new tab no
    // longer originated form the click event.
    const { name, bytes } = document;
    const newWindow = window.open('', '_blank');
    const bytesText = bytes ? ` (${DocumentHelper.getHumanSize(bytes)})` : '';
    if (newWindow) newWindow.document.write(`Laden van '${name}'${bytesText}...<br>`);

    onDownloadDocument(document, type)
      .then(blob => URL.createObjectURL(blob))
      .then(url => {
        if (newWindow) {
          newWindow.location.href = url;
        } else {
          NotificationHelper.toastError('Openen bestand mislukt. Dit wordt mogelijk veroorzaakt door een ad-blocker.');
        }
      })
      .catch(error => {
        if (newWindow) newWindow.document.write('Laden mislukt');
        console.error('Failed to open file', error);
      });
  }
}
